import ar from '@/locale/langs/ar';
import en from '@/locale/langs/en';

export const messages = {
  en,
  ar,
};
